import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import { ParamListBase, useNavigation } from '@react-navigation/native'
import { NativeStackNavigationProp } from '@react-navigation/native-stack'
import { useHomeStore } from '../../stores/home'

// styles

import { colorPalette, globalStyles } from '../../static/styles/global'
import { useTranslation } from 'react-i18next'
import { useFormsStore } from '../../stores/onboarding'

type HomeDetailsHeaderProps = {
  navLabel?: string

  navScreen?: string

  title?: string

  description?: string
  essFormKey?: number
  titleIcon?: React.ReactNode
  params?: any
}

const HomeDetailsHeader = ({
  navLabel = 'home',
  navScreen = 'Onboarding',
  title,
  description,
  essFormKey,
  titleIcon,
  params,
}: HomeDetailsHeaderProps): JSX.Element => {
  const navigation = useNavigation<NativeStackNavigationProp<ParamListBase>>()
  const { t } = useTranslation()
  const { downloadFile } = useFormsStore()

  return (
    <>
      <View
        style={[
          globalStyles.hDirection,

          globalStyles.vCenterItems,

          globalStyles.hBetweenItems,

          globalStyles.mb3
        ]}
      >
        <TouchableOpacity
          style={[
            globalStyles.hDirection,

            globalStyles.vCenterItems,

            globalStyles.flexOne
          ]}
          onPress={() => {
            navigation.navigate(navScreen, params)
          }}
        >
          <View style={[globalStyles.relativePosition, globalStyles.ln6]}>
            <Ionicons
              name="chevron-back"
              size={24}
              color={colorPalette.white}
            />
          </View>

          <Text style={[globalStyles.text, globalStyles.whiteTextColor]}>
            {t(navLabel)}
          </Text>
        </TouchableOpacity>
      </View>

      <View style={[globalStyles.mb3]}>
        {essFormKey ? (
          <TouchableOpacity onPress={() => downloadFile(essFormKey)}>
            <View style={titleIcon ? { flexDirection: 'row', alignItems: 'center' } : {}}>
              <Text
                style={[
                  globalStyles.text,
                  globalStyles.fwBold,
                  globalStyles.fs20,
                  globalStyles.whiteTextColor,
                  globalStyles.textCenter
                ]}
              >
                {title}
              </Text>
              {titleIcon}
            </View>
          </TouchableOpacity>
        ) : (
          <View style={titleIcon ? { flexDirection: 'row', alignItems: 'center' } : {}}>
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwBold,
                globalStyles.fs20,
                globalStyles.whiteTextColor,
                globalStyles.textCenter
              ]}
            >
              {title}
            </Text>
            {titleIcon}
          </View>
        )}
      </View>

      <View>
        <Text style={[globalStyles.text, globalStyles.whiteTextColor, globalStyles.textCenter]}>
          {description}
        </Text>
      </View>
    </>
  )
}

export default HomeDetailsHeader
